<template>
  <div class="attachment-list">
    <!-- <div class="attachment-item" v-for="(item,index) of question.file" :key="index">
      <img class="file-icon" src="@/assets/img/file.png" />
      <div class="upload-status">
        <div class="attachment-name">{{ item.title }}</div>
        <div class="progress">
          <span>大小：{{item.size}}M</span>
          <img class="close-icon" src="@/assets/images/download.png" @click="downloadFile(item.url)" />
        </div>
      </div>
    </div> -->
    <div v-if="question.type==4">
    <div class="attachment-item" v-for="(item,index) of question.file" :key="index">
      <img class="file-icon" src="@/assets/img/file.png" />
      <div class="upload-status">
        <div class="attachment-name">{{ item.title }}</div>
        <div class="progress" v-if="item.size">
          <span>大小：{{item.size}}M</span>
        </div>
        <div class="progress" v-else-if="item.progress">
            <span>大小：{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
        </div>
      </div>
      <img class="close-icon" src="@/assets/images/download.png" @click="downloadFile(item.url)"  />
    </div>
    </div>
    <div v-if="question.type!=4">
        <img class="topic-img" v-for="(item,index) of question.file" :key="index" :src="item.url" @click="imgPreview(item)" alt="">
    </div>
    <van-image-preview v-model="show" :images="image" @close="imgPreviewClose">
    </van-image-preview>
    </div>
</template>
<script>
export default {
  props: {
    question: {
			type: Object,
			default: () => ({ type: 0, title: '' })
		},
   },
  data () {
    return {
      image:[],
      show:false
     }
  },
  computed: { },
  watch: { },
  methods: {
    downloadFile(url){
      window.open(url)
    },
    imgPreview(item){
      this.show=true
      this.image.push(item.url)
      console.log(this.image);
    },
    imgPreviewClose(){
      this.image=[]
      this.show=false
    }
   },
  mounted() { }
}
</script>

<style lang="scss" scoped>
.attachment-list{
  box-sizing: border-box;
  padding: 0 10px;
  .attachment-item{
    // height: 64px;
    background: #ffffff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 5px 16px 5px 6px;
    margin-bottom: 10px;
    border-radius: 4px;
    .attachment-name{
      max-width: 250px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
    }
    .file-icon{
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
    .upload-status{
      .progress{
        display: flex;
        margin-top: 6px;
        align-items: center;
        max-width: 275px;
        ::v-deep .el-progress-bar__outer{
          background-color:#ffffff;
        }
        span{
          font-size: 12px;
          color: #888888;
        }
      }
    }
    .close-icon{
      width: 16px;
      height: 16px;
      margin-left: auto;
      cursor: pointer;
    }
  }
  .topic-img{
    width: 160px;
    height: 90px;
    margin-bottom: 10px;
  }
}
</style>
